import { FETCH_CONTEXT_FULFILLED, FETCH_CONTEXT_REJECTED } from './types';

const initialState = {
  posContext: {
    configurations: {
      environmentUrl: '',
      merchantId: '',
      storeCode: '',
    },
    device: {
      hasScanner: false,
    },
    employee: {},
  },
  pxContext: {
    authorizationToken: '',
  },
  isPending: true,
  error: undefined,
};

export function contextReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_CONTEXT_FULFILLED:
      return {
        ...state,
        posContext: action.payload.posContext,
        pxContext: action.payload.pxContext,
        isPending: false,
        error: undefined,
      };

    case FETCH_CONTEXT_REJECTED:
      return {
        ...state,
        isPending: false,
        error: action.payload.error,
      };

    default:
      return state;
  }
}
